const firebaseConfig = {
  apiKey: 'AIzaSyCf_Sf4EMuK7v3n5qAuy2ILy4UIGdCsQqM',
  authDomain: 'reactwebapp-214f3.firebaseapp.com',
  databaseURL: 'https://reactwebapp-214f3-default-rtdb.firebaseio.com',
  projectId: 'reactwebapp-214f3',
  storageBucket: 'reactwebapp-214f3.appspot.com',
  messagingSenderId: '815752013790',
  appId: '1:815752013790:web:6ee7fb99cb53fa769e9f4f'
};

export default firebaseConfig;
